import React, { Component } from 'react';
import {connect} from 'react-redux'
import * as wActs from '../actions/website-actions';
import * as wConst from "../consts/website-consts";
import {HIDE_WARNING} from "../consts/website-consts";

class Warnings extends Component {
  onClose(e) {
    if(this.timeOut) {
      clearTimeout(this.timeOut);
    }
    this.props.dispatch({type: wConst.HIDE_WARNING, payload: true });
  }
  color() {
    switch(this.props.Warning.Type.toUpperCase()) {
      case "INFO": { return "green" }
      case "WARN": { return "yellow" }
      case "ERROR": { return "red" }
    }
    return "green";
  }
  render() {
    const active = this.props.Warning.Showing ? "active" : "";

    if(active==="active") {
      this.timeOut = setTimeout(() => {
        this.props.dispatch({type: wConst.HIDE_WARNING, payload: false});
      },10000) //10 Sec Timer
    }

    const color = this.color();
    return (
      <div className={`warnings-wrapper ${color} ${active}`}>
        <div className="warning-item">
          <p>{this.props.Warning.Message}</p>
          <a style={{cursor: "pointer"}} onClick={(e) => {this.onClose(e)}} title="" className="close-warning"><i className="fas fa-times"></i></a>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Warning: state.Website.Warning
  }
}
export default connect(mapStateToProps)(Warnings);
